import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { MotionSettingsProvider } from "./components/site/MotionSettings";
import { SiteFrame } from "./components/site/SiteFrame";
import { HomePage } from "./pages/HomePage";
import { JourneyPage } from "./pages/JourneyPage";
import { MediaPage } from "./pages/MediaPage";
import { MindsetPage } from "./pages/MindsetPage";
import { TrainingPage } from "./pages/TrainingPage";

export const athleteProfilePath = "/youth/athletes/chen-haikun";

const routeTitles: Record<string, string> = {
  "/": "陈海鲲 · Water Polo",
  "/journey": "成长轨迹 · 陈海鲲",
  "/training": "训练场 · 陈海鲲",
  "/mindset": "心态节奏 · 陈海鲲",
  "/media": "影像回放 · 陈海鲲"
};

function ExperienceRoutes() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    document.title = routeTitles[location.pathname] ?? routeTitles["/"];
  }, [location.pathname]);

  return (
    <SiteFrame>
      <div className="route-view" key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/journey" element={<JourneyPage />} />
          <Route path="/training" element={<TrainingPage />} />
          <Route path="/mindset" element={<MindsetPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </SiteFrame>
  );
}

export function AthleteApp() {
  return (
    <BrowserRouter basename={athleteProfilePath}>
      <MotionSettingsProvider>
        <ExperienceRoutes />
      </MotionSettingsProvider>
    </BrowserRouter>
  );
}
